import {useParams} from "react-router";
import SeasonContent from "../components/Season/SeasonContent";
import {useEffect} from "react";

type RouteParams = {
    slug: string
}

const Season = () => {
    const {slug} = useParams<RouteParams>();

    useEffect(() => {
        window.location.href = `/event/${slug}`;
    }, [slug]);

    return (
        <SeasonContent slug={slug ?? ''} />
    )
}

export default Season;
